import * as React from "react";
import { Button, Flex, FlexItem } from "@fluentui/react-northstar";

const ButtonComponent = (props) => {
  const { content, onButtonClick } = props;
  return (
    <Flex>
      <Button className="pointsBtn pointerNone" content={content ? content : "Points"} onClick={onButtonClick} />
    </Flex>
  );
};

export default ButtonComponent;
